import { ProgressState } from './progress-state.enum';
export class ProgressStep {
  name: string;
  title: string;
  state: ProgressState;

  constructor(name: string, title: string, state: ProgressState = ProgressState.Pending) {
    this.name = name;
    this.title = title;
    this.state = state;
  }
}
